import { createFileRoute } from '@tanstack/react-router'
import { UiShowcase } from '~/features/dev/UiShowcase'

const tabs = ['uebersicht', 'kader', 'spiele', 'training'] as const
type Tab = (typeof tabs)[number]

export const Route = createFileRoute('/ui')({
  validateSearch: (s: Record<string, unknown>): { tab?: Tab } => (tabs.includes(s.tab as Tab) ? { tab: s.tab as Tab } : {}),
  component: UiShowcase,
})
